import React from 'react';
import c from 'classnames';
import { filesize } from 'filesize';

import { useTranslation } from '@lyearn/i18n';
import { FilePlaceholder } from '@lyearn/icons';
import { useReactNodeView } from '@lyearn/lygo-core';

import { UploadButton } from '../../../components/UploadButton';
import { UploadCard } from '../../../components/UploadCard';
import useDrop from '../../../hooks/useDrop';
import useUpload, { FileType } from '../../../hooks/useUpload';
import { FileComponentEditableProps } from '../types';
import { fileLink } from './style';

const FileComponent: React.FC<FileComponentEditableProps> = (props) => {
  const { href, name, size, type, id } = props;
  const { t } = useTranslation();

  const { node, updateAttrs } = useReactNodeView();

  const updateEditorState = React.useCallback(
    (file: FileType) => {
      updateAttrs({
        href: file.url,
        name: file.name,
        type: file.extension,
        size: filesize(file.size),
      });
    },
    [updateAttrs],
  );

  const { uppy, currentFile } = useUpload(updateEditorState, node?.attrs.id);
  useDrop(node, updateAttrs, uppy);

  const isUploading = !!currentFile && !currentFile.url;

  return (
    <div className="lygo-file">
      {href ? (
        <div className="mt-16">
          <a
            className={c('w-full', fileLink)}
            href={href}
            rel="noreferrer noopener"
            target="_blank"
            title={name}>
            <UploadCard isUploading={false} name={name} size={size} type={type} />
          </a>
        </div>
      ) : isUploading ? (
        <div className="mt-16">
          <UploadCard
            isUploading
            PlaceholderIcon={FilePlaceholder}
            name={currentFile?.name}
            progress={currentFile?.fileProgress as number}
          />
        </div>
      ) : (
        <UploadButton
          PlaceholderIcon={FilePlaceholder}
          id={id as string}
          placeHolder={t('Lygo:UploadFile')}
        />
      )}
    </div>
  );
};

export default FileComponent;
